import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './index.scss';

class Dialog extends Component {
  state = { modalActive: false };

  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick = (e, callback) => {
    if (typeof callback === 'function') {
      callback(e);
    }
  };

  render() {
    const { header, children, buttons, errorMenssage } = this.props;

    return (
      this.state.modalActive && (
        <div className={`dialog-${this.state.modalActive ? 'active' : 'hide'}`}>
          <div className="dialog-overlay" />
          <div className="dialog-box">
            <div className={errorMenssage !== undefined ? 'dialog-header-error' : 'dialog-header'}>
              {header}
            </div>
            <div className="dialog-content">{children}</div>
            <div className={errorMenssage !== undefined ? 'dialog-footer-error' : 'dialog-footer'}>
              {buttons.map(
                btn => (
                  <button
                    key={btn.title}
                    type="button"
                    onClick={e => this.handleClick(e, btn.callback)}
                  >
                    <span>{btn.title}</span>
                  </button>
                ),
                this
              )}
            </div>
          </div>
        </div>
      )
    );
  }
}

Dialog.propTypes = {
  header: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  buttons: PropTypes.arrayOf(PropTypes.object).isRequired,
  errorMenssage: PropTypes.string
};

export default Dialog;
